import { render, staticRenderFns } from "./DodajOdlocbe.vue?vue&type=template&id=c11deaf4&"
import script from "./DodajOdlocbe.vue?vue&type=script&lang=js&"
export * from "./DodajOdlocbe.vue?vue&type=script&lang=js&"
import style0 from "./DodajOdlocbe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports